import { render, staticRenderFns } from "./PaymentItem.vue?vue&type=template&id=28cdbc8c&"
import script from "./PaymentItem.vue?vue&type=script&lang=ts&"
export * from "./PaymentItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports